enum DatePickerType {
  LAST_PERIOD = "lastPeriod",
  MONTH = "month"
}

export default DatePickerType
